import { render } from "./BaoCaoXangDauMobile.vue?vue&type=template&id=4a2052d6&scoped=true"
import script from "./BaoCaoXangDauMobile.vue?vue&type=script&lang=js"
export * from "./BaoCaoXangDauMobile.vue?vue&type=script&lang=js"

import "./BaoCaoXangDauMobile.vue?vue&type=style&index=0&id=4a2052d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2052d6"]])

export default __exports__